<template>
<div v-if="companies && companies.length > 0" class="container companies">
  <div class="companies-big-items">
    <template v-if="!dark">
      <swiper v-if="onClickWaiter" ref="swip" :options="swiperOption">
        <swiper-slide v-for="(slide, counter) in slidesWithLogo"
                      :key="counter">
          <div v-for="(company, key) in slide"
               :key="company.$id"
               @click="switchPopup(counter * 10 + key)"
               class="companies-item companies-item-big col-md-3 col-xs-4">
            <img :src="company.logo.$src"/>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </template>

    <template v-else>
      <div v-if="company && company.logo"
           :key="company.$id"
           class="companies-item companies-item-big col-md-3 col-xs-4"
           v-for="(company, key) in slides"
           @click="switchPopup(key)">
        <img :src="company.logo.$src"/>
      </div>
    </template>
  </div>

</div>

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Slider',
  props: ['slides', 'dark'],
  mounted() {
    setTimeout(() => {
      this.onClickWaiter = true;
    }, 300);
  },
  data() {
    return {
      onClickWaiter: false,
      slide: 0,
      swiperOption: {
        direction: 'horizontal',
        speed: 500,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'bullets',
        },
        centeredSlides: true,
        preventClicks: false,
        grabCursor: false,
        autoHeight: true,
        slidesPerView: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      companies: 'companies',
      popup: 'popup',
      lang: 'lang',
    }),

    companiesWithLogo() {
      return this.slides.filter(company => company.logo && company.logo.$src);
    },

    slidesWithLogo() {
      const companiesWithLogo = this.companiesWithLogo.slice(0);
      const slidesAmount = Math.ceil(companiesWithLogo.length / 10);
      const slides = [];

      for (let i = 0; i < slidesAmount; i += 1) {
        slides.push(companiesWithLogo.splice(0, 10));
      }

      return slides;
    },
  },
  methods: {
    switchPopup(slide) {
      let current = slide - 1;

      if (current === this.companiesWithLogo.length) {
        current = 0;
      } else if (current > this.companiesWithLogo.length) {
        current = 0;
      } else if (current < 0) {
        current = this.companiesWithLogo.length - 1;
      }

      if (
        this.companiesWithLogo &&
        this.companiesWithLogo.length &&
        this.companiesWithLogo[current]
      ) {
        const slug = this.companiesWithLogo[current].$slug;
        this.openPopup(slug);
      }
    },
    openPopup(slug) {
      this.$store.commit('FETCH_COMPANY', slug);
      this.$store.dispatch('popupState', true);
    },
  },
};
</script>


<style>
.page{
  &-clients{
    .companies{
      position: relative;
      margin-bottom: -50px;
      margin-top: 50px;
      max-width: 100%;
      margin-left: 0;
      z-index: 999;
      padding: 0;

      @media (max-width: $mediaMini) {
        margin-top: 0;
      }

      img{
        max-width: 80%;
      }

      &-item{
        transition: all .3s ease-in-out;
        vertical-align: middle;
        display: inline-block;
        filter: grayscale(1);
        margin-bottom: 40px;
        margin-right: 14px;
        cursor: pointer;
        float: none;

        &:first-child{
          padding-left: 0;
        }


        &-active,
        &:hover{
          filter: grayscale(0);
          img{
            transform: scale(1.05);
          }
        }

        img{
          transition: all .3s ease-in-out;
          transform-origin: center center;
          display: inline-block;
          max-height: 110px;
          max-width: 100%;
          height: auto;
          width: auto;
        }

        &-big{
          img{
            -ms-interpolation-mode: bicubic;
          }
        }
      }


      &-big-items{
        padding-bottom: 30px;

        .companies-item{
          margin-bottom: 40px;
          text-align: center;
          min-width: 100px;
          margin-right: 0;
          margin-left: 0;

          @media (max-width: $mediaTiny) {
            margin-bottom: 10px;
          }

          @media (min-width: $mediaTiny) {
            max-width: 20%;
          }

          img{
            display: inline-block;
            width: inherit;
            min-width: 80px;
            max-width: 90%;
            height: auto;
            @media (min-width: $mediaMob) {
              min-width: 110px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Slider.vue